<template>
  <div v-if="isImpersonated" class="impersonation-banner">
    <div class="alert alert-gradient-warning d-flex align-items-center justify-content-between mb-0" role="alert">
      <div class="d-flex align-items-center">
        <font-awesome-icon icon="user-secret" class="me-2" />
        <span>
          Du bist als <strong>{{ authStore.user?.firstName }} {{ authStore.user?.lastName }}</strong> 
          ({{ authStore.user?.email }}) eingeloggt.
        </span>
      </div>
      <button
        type="button"
        class="btn btn-primary btn-sm"
        @click="stopImpersonation"
        title="Zurück zum Admin-Account"
      >
        <font-awesome-icon icon="sign-out-alt" class="me-1" />
        Impersonation beenden
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'

const authStore = useAuthStore()
const router = useRouter()

const isImpersonated = computed(() => {
  return authStore && authStore.isImpersonated ? authStore.isImpersonated() : false
})

const stopImpersonation = () => {
  authStore.stopImpersonation()
  router.push('/admin')
}
</script>
